import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './siteListActionType';
import * as actions from './siteListActions';
import * as services from './siteListServices';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';

// Fetch Site List Saga
function* fetchSiteListSaga(action) {
    try {
        const response = yield call(services.getAllSiteList, action.payload);

        if (response?.success) {
            const data = {
                isCustomView: false, 
                fieldName: [], 
                fieldValues: response.values || [], 
                data: response.values || []
            };
            yield put(actions.fetchSiteListSuccess(data));
        } else {
            yield put(actions.fetchSiteListFailure('No data found'));
        }
    } catch (error) {
        console.error('SITE List Fetch Error:', error);
        yield put(actions.fetchSiteListFailure('Failed to fetch facility list'));
        // Swal.fire('Error', 'Failed to load SITE List', 'error');
    }
}

// Fetch Practice Dropdown Saga
function* fetchPracticeDropdownSaga() {
    try {
        const response = yield call(services.getPracticeDropdownData);
        
        if (response?.success) {
            yield put(actions.fetchPracticeDropdownSuccess(response.values || []));
        } else {
            yield put(actions.fetchPracticeDropdownFailure('Failed to fetch practice dropdown'));
        }
    } catch (error) {
        console.error('Practice Dropdown Fetch Error:', error);
        yield put(actions.fetchPracticeDropdownFailure('Failed to fetch practice dropdown'));
    }
}

// Fetch Site Dropdown Saga
function* fetchSiteDropdownSaga() {
    try {
        const response = yield call(services.getSiteDropdownData);
        
        if (response?.success) {
            yield put(actions.fetchSiteDropdownSuccess(response.values || {}));
        } else {
            yield put(actions.fetchSiteDropdownFailure('Failed to fetch facility dropdown'));
        }
    } catch (error) {
        console.error('Site Dropdown Fetch Error:', error);
        yield put(actions.fetchSiteDropdownFailure('Failed to fetch facility dropdown'));
    }
}

// Fetch Sub Practice Dropdown Saga
function* fetchSubPracticeDropdownSaga() {
    try {
        const response = yield call(services.getSubPracticeDropdownData);
        
        if (response?.success) {
            yield put(actions.fetchSubPracticeDropdownSuccess(response || {}));
        } else {
            yield put(actions.fetchSubPracticeDropdownFailure('Failed to fetch sub-practice dropdown'));
        }
    } catch (error) {
        console.error('Sub Practice Dropdown Fetch Error:', error);
        yield put(actions.fetchSubPracticeDropdownFailure('Failed to fetch sub-practice dropdown'));
    }
}

// Save Bulk Practice Site Saga
function* saveBulkPracticeSiteSaga(action) {
    try {
        const response = yield call(services.saveBulkPracticeSiteData, action.payload);
        
        if (response?.success) {
            yield put(actions.saveBulkPracticeSiteSuccess(response));
            
            // Show success message
            SweetAlert.success({
                title: 'Success!',
                text: 'Bulk practice facility mapping saved successfully.',
                timer: 2000,
                showConfirmButton: true
            });
            
            // yield put(actions.fetchSiteListRequest({}));
        } else {
            yield put(actions.saveBulkPracticeSiteFailure(response?.errorMessage || 'Failed to save bulk practice facility mapping'));
            
            // Show error message
            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage || 'Failed to save bulk practice facility mapping.',
                showConfirmButton: true
            });
        }
    } catch (error) {
        console.error('Save Bulk Practice Site Error:', error);
        yield put(actions.saveBulkPracticeSiteFailure('Failed to save bulk practice facility mapping'));
        
        // Show error message
        SweetAlert.error({
            title: 'Error!',
            text: error.message || 'An error occurred while saving bulk practice facility mapping.',
            showConfirmButton: true
        });
    }
}




// Sagas
export default function* watchsiteListSaga() {
    yield takeEvery(types.FETCH_SITE_LIST_REQUEST, fetchSiteListSaga);
    yield takeEvery(types.FETCH_PRACTICE_DROPDOWN_REQUEST, fetchPracticeDropdownSaga);
    yield takeEvery(types.FETCH_SITE_DROPDOWN_REQUEST, fetchSiteDropdownSaga);
    yield takeEvery(types.FETCH_SUB_PRACTICE_DROPDOWN_REQUEST, fetchSubPracticeDropdownSaga);
    yield takeEvery(types.SAVE_BULK_PRACTICE_SITE_REQUEST, saveBulkPracticeSiteSaga);
}


